import React from "react";
import { InputNumber } from "antd";
import { useTranslation } from "react-i18next";
import { hoursSavedPerMonth, PLATFORM_HOURS_PER_CASE_DEFAULT } from "./roiCalc";

/** US-405: manual hours vs platform — full-width landing section styling. */
export function RoiCalculator() {
  const { t } = useTranslation();
  const [casesPerMonth, setCasesPerMonth] = React.useState(12);
  const [manualHours, setManualHours] = React.useState(4);
  const saved = hoursSavedPerMonth(casesPerMonth, manualHours);

  return (
    <section
      className="welcome-section welcome-roi"
      data-testid="roi-calculator"
      aria-labelledby="roi-heading"
    >
      <div className="welcome-wrap">
        <h2 id="roi-heading" className="welcome-section-title-inline">
          {t("investor.roi.title")}
        </h2>
        <p className="welcome-section-lead-inline">{t("investor.roi.lead")}</p>
        <div className="welcome-roi__controls">
          <label className="welcome-roi__field">
            <span className="welcome-roi__label">{t("investor.roi.casesPerMonth")}</span>
            <InputNumber
              size="large"
              min={0}
              max={10000}
              value={casesPerMonth}
              onChange={(v) => setCasesPerMonth(typeof v === "number" ? v : 0)}
              data-testid="roi-cases"
              className="welcome-roi__input"
            />
          </label>
          <label className="welcome-roi__field">
            <span className="welcome-roi__label">{t("investor.roi.manualHours")}</span>
            <InputNumber
              size="large"
              min={0}
              max={200}
              step={0.5}
              value={manualHours}
              onChange={(v) => setManualHours(typeof v === "number" ? v : 0)}
              data-testid="roi-manual-hours"
              className="welcome-roi__input"
            />
          </label>
        </div>
        <p className="welcome-roi__result" data-testid="roi-saved">
          <span className="welcome-roi__metric">{saved.toFixed(1)}</span>
          <span className="welcome-roi__metric-copy">
            {t("investor.roi.savedUnit")}{" "}
            <span className="welcome-roi__note">
              {t("investor.roi.savedNote", { platform: PLATFORM_HOURS_PER_CASE_DEFAULT })}
            </span>
          </span>
        </p>
      </div>
    </section>
  );
}
